import { VerifyRecaptchaRequest } from 'vopay';
import { useState } from 'react';
import { api } from '@/services/api.config';

export default function useVerifyRecaptcha() {
  const [verifying, setVerifying] = useState(false);

  async function verifyRecaptcha(params: VerifyRecaptchaRequest) {
    try {
      setVerifying(true);
      const res = await api.postVerifyRecaptcha(params);

      if (!res.Success) throw new Error(res.ErrorMessage);

      return res;
    } catch (error) {
      console.error(error);
      throw error;
    } finally {
      setVerifying(false);
    }
  }

  return { verifying, verifyRecaptcha };
}
